"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _breakpoint = _interopRequireDefault(require("../common/breakpoint"));
// { fontSize, lineHeight, margin } pixels
var scaleMap = {
  h1: {
    lg: {
      fontSize: 40
    },
    xs: {
      fontSize: 30
    }
  },
  h2: {
    lg: {
      fontSize: 34
    },
    xs: {
      fontSize: 24
    }
  },
  h3: {
    lg: {
      fontSize: 28
    },
    xs: {
      fontSize: 20
    }
  },
  h4: {
    lg: {
      fontSize: 22 // not provided so mantaining the same as xs
    },
    xs: {
      fontSize: 22
    }
  },
  h5: {
    lg: {
      fontSize: 18 // not provided so mantaining the same as xs
    },
    xs: {
      fontSize: 18
    }
  },
  h6: {
    lg: {
      fontSize: 16 // not provided so mantaining the same as xs
    },
    xs: {
      fontSize: 16
    }
  },
  default: {
    lg: {
      fontSize: 16
    },
    xs: {
      fontSize: 16
    }
  },
  input: {
    lg: {
      fontSize: 16,
      margin: 'initial'
    },
    // not provided so mantaining the same as xs
    xs: {
      fontSize: 16,
      margin: 'initial'
    }
  },
  small: {
    lg: {
      fontSize: 12,
      lineHeight: 'inherit',
      margin: 'initial'
    },
    // not provided so mantaining the same as xs
    xs: {
      fontSize: 12,
      lineHeight: 'inherit',
      margin: 'initial'
    }
  }
};
var defaultScreenSize = 'xs';
var unit = 'px';
var getTypeScale = function getTypeScale() {
  var scaleMapKeys = Object.keys(scaleMap);
  var typeScale = {};
  var screenSizeKeys;
  var mediaCss;
  scaleMapKeys.forEach(function (type) {
    screenSizeKeys = Object.keys(scaleMap[type]);
    typeScale[type] = screenSizeKeys.reduce(function (css, screenSize) {
      mediaCss = "@media (min-width: ".concat(_breakpoint.default[screenSize].min, ") {");
      return "\n        ".concat(css, "\n        ").concat(screenSize !== defaultScreenSize ? mediaCss : '', "\n        font-size: ").concat(scaleMap[type][screenSize].fontSize).concat(unit, ";\n        line-height: ").concat(scaleMap[type][screenSize].lineHeight || '1.5', ";\n        margin: ").concat(scaleMap[type][screenSize].margin || '0', ";\n        ").concat(screenSize !== defaultScreenSize ? '}' : '', "\n      ");
    }, '');
  });
  return typeScale;
};
var typeScale = getTypeScale();
var _default = exports.default = typeScale;